export class WindowElementPreparer {
  prepare = element => {
    let windowElement = element;
    windowElement.uValue = windowElement.windowsType.uValue;
    windowElement.winGain = windowElement.windowsType.winGain;
    return windowElement;
  };
}
